import Div from '@ui/layout/Div'
import { string } from 'prop-types'
import '@assets/scss/atoms/loader.scss'

const Loader = ({ cssClass = 'loader' }) => {
  return (
    <Div cssClass='loader-holder'>
      <Div cssClass={cssClass}></Div>
    </Div>
  )
}

Loader.propTypes = {
  cssClass: string
}

export default Loader